import { InstantSearchConfig, CollectionPageConfig } from '../algolia/config';
import { ListenerEvent, ListenerFunction } from '../algolia/_helpers';

export { getSiteCode } from '../scripts/_global';

// Thin coordinator: heavy React trees load via dynamic import() on demand to keep the per-page footprint small.

const searchResultsEl = document.getElementById('algolia-search-results');
if (searchResultsEl) {
  import('../algolia/mount-search-results').then(({ mountSearchResults }) => {
    mountSearchResults(searchResultsEl);
  });
}

window.AlgoliaCollectionPage = {
  init: (config: CollectionPageConfig = {}) => {
    import('../algolia/mount-collection-list').then(({ mountCollectionPage }) => {
      mountCollectionPage(config);
    });
  },
};

let instantSearchRequested = false;
let pendingInstantSearchConfig: InstantSearchConfig | null = null;
const queuedListeners: Array<{ event: ListenerEvent; listener: ListenerFunction }> = [];
let liveHandle: { on: (event: ListenerEvent, listener: ListenerFunction) => void } | null = null;

function loadInstantSearch() {
  if (instantSearchRequested) return;
  instantSearchRequested = true;

  const config = pendingInstantSearchConfig;
  if (!config) return;

  detachBootstrapListeners(config.triggerClassName);

  import('../algolia/mount-instant-search')
    .then(({ mountInstantSearch }) => {
      liveHandle = mountInstantSearch({ ...config, initialOpen: true });
      queuedListeners.splice(0).forEach(({ event, listener }) => liveHandle?.on(event, listener));
    })
    .catch(() => {
      // Recover if the chunk fails to load (e.g. transient network error) so the user can retry.
      instantSearchRequested = false;
      attachBootstrapListeners(config.triggerClassName);
    });
}

function handleTriggerClick() {
  loadInstantSearch();
}

function attachBootstrapListeners(triggerClassName: string) {
  document.querySelectorAll(`.${triggerClassName}`).forEach((el) => {
    el.addEventListener('click', handleTriggerClick);
  });
}

function detachBootstrapListeners(triggerClassName: string) {
  document.querySelectorAll(`.${triggerClassName}`).forEach((el) => {
    el.removeEventListener('click', handleTriggerClick);
  });
}

window.AlgoliaInstantSearch = {
  init: (config: InstantSearchConfig) => {
    pendingInstantSearchConfig = config;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => attachBootstrapListeners(config.triggerClassName), { once: true });
    } else {
      attachBootstrapListeners(config.triggerClassName);
    }

    return {
      on: (event: ListenerEvent, listener: ListenerFunction) => {
        if (liveHandle) {
          liveHandle.on(event, listener);
        } else {
          queuedListeners.push({ event, listener });
        }
      },
    };
  },
};
